export const marketplace = {
  marketplaceSearchInputPlaceholderTitle: 'Pesquisar',
  marketplaceDetailsCurtainCopyOptionTitle: 'Copiar link',
  marketplaceDetailsCurtainFlagOptionTitle: 'Denunciar conteúdo',
  marketplaceDetailsCurtainCopiedAlertText: 'Link copiado!',
  marketplaceDetailsFlagCurtainTitle: 'Denunciar',
  marketplaceReportedCurtainContent: 'Conteúdo denunciado',
  marketplaceAllItems: 'Todos os itens',
  marketplaceWantToBuy: 'Quero comprar {item} de {appname}'
}
